import system from './system/en'

export default {
  common: system.common,
  navbar: system.navbar,
  footer: system.footer,
  home: system.home,
  abort: system.abort,
  services: system.services,
  power: system.power,
  news: system.news,
  contact: system.contact
}



// WEBPACK FOOTER //
// ./src/lang/en.js